import { WaterNetworkBase } from './base/water-network-base';

export class WaterNetwork extends WaterNetworkBase { }